import { render, staticRenderFns } from "./avaliationResultCard.vue?vue&type=template&id=18dabfab"
import script from "./avaliationResultCard.vue?vue&type=script&lang=js"
export * from "./avaliationResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports